import { Component, inject, Input, OnInit } from '@angular/core';
import { InputSelectComponent } from '../../../../common-components/input-select/input-select.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { IdNameModel } from '../../../../models/idname.model';
import { AssignmentService } from '../../../../services/assignment.service';
import { tap } from 'rxjs';
import { FiveSArea } from '../../../../models/five-s-area.interface';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-region-view',
  standalone: true,
  imports: [
    InputSelectComponent,
    ReactiveFormsModule,
    TranslocoDirective
  ],
  templateUrl: './region-view.component.html',
  styleUrl: './region-view.component.scss'
})
export class RegionViewComponent implements OnInit {
  @Input({ required: true }) public areaFormGroup = new FormGroup({ id: new FormControl<string>(''), name: new FormControl('') });
  @Input({ required: true }) public locationFormGroup = new FormGroup({ id: new FormControl<string>(''), name: new FormControl('') });
  protected regions: FiveSArea[] = [];
  protected areaOptions: IdNameModel[] = [];
  protected locationOptions: IdNameModel[] = []

  private assignmentService = inject(AssignmentService);

  public ngOnInit() {
    this.assignmentService.getAreas().pipe(
      tap((areas) => {
        this.regions = areas;
        this.areaOptions = this.regions.map(x => ({ id: x.id, name: x.name }) as IdNameModel).sort((a, b) => a.name.localeCompare(b.name, 'en', { numeric: true }))
      })
    ).subscribe()

    this.areaFormGroup.valueChanges.pipe(
      tap((area) => {
        this.locationFormGroup.reset();
        this.locationOptions = this.regions.find(x => x.id === area.id)?.locations.sort((a, b) => a.name.localeCompare(b.name, 'en', { numeric: true })) ?? []
      })
    ).subscribe()
  }
}
